module.exports = ".align-col{\n    float: left;;\n}\n.align-span-img{\n    text-align:center;\n}"